import React from 'react'
import IntelLayout from './components/IntelLayout'
import BulkServiceability from '../bulk_serviceability/BulkServiceability'

// Bulk Serviceability rendered inside the Serviceability Intel module — keeps the Intel
// tab strip on top (embedded = the tool hides its own page title to avoid a duplicate).
export default function BulkServiceabilityIntel() {
  return (
    <IntelLayout title='Bulk Serviceability'>
      <BulkServiceability embedded />
    </IntelLayout>
  )
}
